import { trackEvent } from '@/lib/ga'
import { type GaEvent } from '@/lib/ga/constants/gaEvent'

export function trackMenuItemClick(categoryId: number, buttonType: string) {
  trackEvent({
    action: `catId=${categoryId}` as GaEvent,
    label: `btn=${buttonType}`,
  })
}
